<figure *ngIf="content">
  <div class="video__container">
    <iframe
      [src]="url"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
  <figcaption *ngIf="content.caption">{{ content.caption }}</figcaption>
</figure>
